/* eslint-disable */
export enum EditionStage {
  beforeCampaign = 'beforeCampaign underway',
  retention = 'Retention underway',
  campaign = 'Campaign underway',
  afterCampaign = 'afterCampaign underway'
}
